export const GET_MONTS = {
    'Mensual': 1,
    'Trimestral': 3,
    'Cada 6 meses': 6,
    'Anual': 12,
};

export const DEFAULT_MONTHS = 12;